
/**
 * Custom for dragging operations relative to the element provided.
 * Hooks for callbacks.
 * Support for legacy browsers.
 * Should decouple 'dragging': data-attribute
 */



(function ($) {

    $.fn.dragScoller = function (options) {

        var settings = {
                sensitivity: 1,
                sensitivityMultiplier: 2.0,
                grabClass: 'grab',    //not used, assumes is already applied
                grabbingClass: 'grabbing',
                vScrollEnabled: true,
                hScrollEnabled: true
            },
            lastMousePos = {x: 0, y: 0},
            dragging = false,
            bbox = {xL: 0, xR: 0, yT: 0, yB: 0},
            $el = this,
            $innerDiv = $el.children(':first').addClass(settings.grabClass);  // what is actually scrolled, used for applying the grabbing class

        options && $.extend(settings, options); /* export to see if applied if want to toggle */

        $el.data('grabbyHandApplied', true);

        $el.on('mousedown', function(e) {

            if (e.which === 1) { //left click

                e.preventDefault();

                $innerDiv.addClass(settings.grabbingClass);
                lastMousePos = $.fn.getMouseCoordinate(e); //start with initial values
                bbox = $el.getBBox();
                dragging = true;

                $el.data('dragging', true); //for export
            }

        }).on('mouseup', function(e) {

            e.preventDefault();

            dragging = false;
            $el.data('dragging', false); //for export


            bbox = null;
            $innerDiv.removeClass(settings.grabbingClass);

        }).on('mousemove', function(e) {

            e.preventDefault();

            var $win = $(window),
                s = settings;
            
            if (dragging) {


                var mousePageX = e.pageX - $win.scrollLeft(),
                    mousePageY = e.pageY - $win.scrollTop();

                // If out of bounds, trigger a mouse up and exit
                if (mousePageX <= bbox.xL || mousePageX >= bbox.xR || mousePageY <= bbox.yT || mousePageY >= bbox.yB) {
                    $el.trigger('mouseup', e);
                    return false;
                }

                var dx = (e.pageX - lastMousePos.x) * s.sensitivityMultiplier * s.sensitivity,
                    dy = (e.pageY - lastMousePos.y) * s.sensitivityMultiplier * s.sensitivity;

                lastMousePos = $.fn.getMouseCoordinate(e);

                if (dx === 0 && dy === 0) {
                    return;
                }

                s.hScrollEnabled && $el.scrollLeft($el.scrollLeft() - dx);
                s.vScrollEnabled && $el.scrollTop($el.scrollTop() - dy);
            }
        });


        this.destroyDragScroller = function () {

            $el.off('mousedown mouseup mousemove')
                .data('grabbyHandApplied', '');

            $innerDiv.removeClass(settings.grabClass);
        };

        // TODO: implement these function
        this.toggleVerticalScroll = function(turnOn) {
             settings.vScrollEnabled = turnOn ? true : false;
        };

        this.toggleHorizontalScroll = function (turnOn) {
            settings.hScrollEnabled = turnOn ? true : false;
        };

        return this;
    };


    /**
     * Return 'bounding box' of element for use in grabby-hand scrolling.
     * Return bbox of dimensions of element at the document level -- only used in this grabby hand plugin
     */
    $.fn.getBBox = function(options) {
        var settings = {
            yBuffer: 5,
            xBuffer: 5
        },
       outerLeft = this.offset().left - $(window).scrollLeft(),
       outerTop = this.offset().top - $(window).scrollTop();

       options && $.extend(settings, options);

       return {
            xL: outerLeft + settings.xBuffer,
            xR: outerLeft + this.width() - settings.xBuffer,
            yT: outerTop + settings.yBuffer,
            yB: outerTop + this.height() - settings.yBuffer
        };
    };


}(jQuery));


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/drag.js
 ** module id = 457
 ** module chunks = 0
 **/